import { computed, h, reactive, VNode } from "vue";
import MicroButton from "../components/room/bar_items/MicroButton.vue";
import CameraButton from "../components/room/bar_items/CameraButton.vue";
import RecordingBarItem from "../components/room/bar_items/RecordingBarItem.vue";
import HandButton from "../components/room/bar_items/HandButton.vue";
import ChatButton from "../components/room/bar_items/ChatButton.vue";
import UsersButton from "../components/room/bar_items/UsersButton.vue";
import ShareScreenButton from "../components/room/bar_items/ShareScreenButton.vue";
import MoreButton from "../components/room/bar_items/MoreButton.vue";
import CallTimer from "../components/room/bar_items/CallTimer.vue";
import EndCallButton from "../components/room/bar_items/EndCallButton.vue";
import { platform } from "../utils/platform";
import { isSelfAdmin } from "./adminsState";
import { recordState } from "./recordState";
import RecordMoreItem from "../components/room/bar_items/more/RecordMoreItem.vue";
import ScreenShareMoreItem from "../components/room/bar_items/more/ScreenShareMoreItem.vue";
import UsersMoreAction from "../components/room/bar_items/more/UsersMoreAction.vue";
import HandMoreAction from "../components/room/bar_items/more/HandMoreAction.vue";
import AllMicroOffMoreAction from "../components/room/bar_items/more/AllMicroOffMoreAction.vue";
import ChangeModeMoreAction from "../components/room/bar_items/more/ChangeModeMoreAction.vue";
import CopyLinkMoreAction from "../components/room/bar_items/more/CopyLinkMoreAction.vue";
import ChatClearMoreAction from "../components/room/bar_items/more/ChatClearMoreAction.vue";
import ShowSpeakerMoreAction from "../components/room/bar_items/more/ShowSpeakerMoreAction.vue";
// import { screenShareState } from "./screenShareState";
import OpenSettingsMoreItems from "../components/room/bar_items/more/OpenSettingsMoreItems.vue";
import FullScreenButton from "../components/room/bar_items/FullScreenButton.vue";
import FullScreenMoreItem from "../components/room/bar_items/more/FullScreenMoreItem.vue";
import ShowChatMoreItem from "../components/room/bar_items/more/ShowChatMoreItem.vue";
import ReactionButton from "../components/room/bar_items/ReactionButton.vue";
import ReactionButtonSpacer from "../components/room/bar_items/ReactionButtonSpacer.vue";
import { isScreenSharing } from "./screenShareState";

type Action = {
  name: string;
  bar?: {
    /**
     * Приоритет скрытия кнопки и переноса в список действий
     * Чем больше приоритет, тем более вероятно она останется отображаемой
     */
    priority: number;
    render: () => VNode | null;
    hide?: () => boolean;
    position: "left" | "right" | "center";
    /**
     * Сортировка кнопок в контейнере
     * 0 - левее
     */
    index: number;
  };
  list?: {
    render: (props: { close: () => void }) => VNode | null;
    /**
     * Сортировка кнопок в контейнере
     * 0 - выше
     */
    index: number;
    hide?: () => boolean;
  };
};

const barActions: Action[] = [
  {
    name: "micro",
    bar: {
      priority: 999,
      render: () => h(MicroButton),
      position: "left",
      index: 0,
    },
  },
  {
    name: "camera",
    bar: {
      priority: 999,
      render: () => h(CameraButton),
      position: "left",
      index: 1,
    },
  },
  {
    name: "recording",
    bar: {
      priority: 500,
      render: () => h(RecordingBarItem),
      position: "left",
      hide: () => !isSelfAdmin.value && !recordState.recording,
      index: 2,
    },
    list: {
      index: 0,
      render: ({close}) => h(RecordMoreItem, { close }),
      hide: () => !isSelfAdmin.value && !recordState.recording,
    },
  },
  {
    name: "reaction",
    bar: {
      priority: 999,
      render: () => h(ReactionButton),
      position: "center",
      index: 0,
    }
  },
  {
    name: "reaction-spacer",
    bar: {
      priority: -1,
      render: () => h(ReactionButtonSpacer),
      position: "center",
      index: 999
    }
  },
  {
    name: "hand",
    bar: {
      priority: 100,
      render: () => h(HandButton),
      position: "center",
      index: 1,
    },
    list: {
      index: 4,
      render: ({close}) => h(HandMoreAction, { close }),
    }
  },
  {
    name: "chat",
    bar: {
      priority: 200,
      render: () => h(ChatButton),
      position: "center",
      index: 2,
    },
    list: {
      index: 11,
      render: ({close}) => h(ShowChatMoreItem, { close }),
    }
  },
  {
    name: "users",
    bar: {
      priority: 150,
      render: () => h(UsersButton),
      position: "center",
      index: 3,
    },
    list: {
      index: 2,
      render: ({close}) => h(UsersMoreAction, { close }),
    },
  },
  {
    name: "screenshare",
    bar: {
      priority: 700,
      render: () => h(ShareScreenButton),
      hide: () => platform === "mobile",
      position: "center",
      index: 4,
    },
    list: {
      index: 1,
      render: ({close}) => h(ScreenShareMoreItem, { close }),
      hide: () => platform === "mobile",
    },
  },
  {
    name: "fullscreen",
    bar: {
      priority: 90,
      render: () => h(FullScreenButton),
      position: "center",
      hide: () => platform === "mobile",
      index: 5,
    },
    list: {
      index: 10,
      render: ({close}) => h(FullScreenMoreItem, { close }),
      hide: () => platform === "mobile",
    },
  },
  {
    name: "more",
    bar: {
      priority: 999,
      render: () => h(MoreButton),
      position: "center",
      index: 6,
    },
  },
  {
    name: "calltimer",
    bar: {
      priority: 999,
      render: () => h(CallTimer),
      position: "right",
      index: 0,
    },
  },
  {
    name: "endcall",
    bar: {
      priority: 999,
      render: () => h(EndCallButton),
      position: "right",
      index: 1,
    },
  },
  {
    name: "allOffmicro",
    list: {
      index: 5,
      render: ({close}) => h(AllMicroOffMoreAction, { close }),
      hide: () => !isSelfAdmin.value,
    }
  },
  {
    name: "changemode",
    list: {
      index: 6,
      render: ({close}) => h(ChangeModeMoreAction, { close }),
    }
  },
  {
    name: "copyLink",
    list: {
      index: 7,
      render: ({close}) => h(CopyLinkMoreAction, { close }),
      hide: () => !isSelfAdmin.value,
    }
  },
  {
    name: "chatClear",
    list: {
      index: 8,
      render: ({close}) => h(ChatClearMoreAction, { close }),
      hide: () => !isSelfAdmin.value,
    }
  },
  {
    name: "showSpeaker",
    list: {
      index: 9,
      render: ({close}) => h(ShowSpeakerMoreAction, { close }),
      hide: () => !isScreenSharing(),
    }
  },
  {
    name: "openSettings",
    list: {
      index: 100,
      render: ({close}) => h(OpenSettingsMoreItems, { close }),
    }
  }
];

export const barSizeState = reactive({
  currentBarWidth: 1000,
  yPadding: 8,
  xPadding: 12,
  widths: {} as Record<string, number>,
});

export const barGap = computed(() => {
  return barSizeState.currentBarWidth >= 800 ? 24 : 12;
});

const baseBtnWidth = 44;

export const barItems = computed(() => {
  const actions = barActions.filter((a) => a.bar);
  actions.sort((a, b) => b.bar!.priority - a.bar!.priority);
  const filteredHiden = actions.filter((a) => !a.bar!.hide?.());
  const resActions = [] as Action[];
  let acc = barSizeState.xPadding * 2;
  for (let i = 0; i < filteredHiden.length; i++) {
    const action = filteredHiden[i];
    const nextAcc = acc + barSizeState.widths[action.name] || baseBtnWidth;
    if (nextAcc <= barSizeState.currentBarWidth) {
      resActions.push(action);
      acc = nextAcc;
    } else {
      break;
    }
    if (i < actions.length - 1) {
      acc += barGap.value;
    }
  }

  const left = resActions
    .filter((a) => a.bar!.position === "left")
    .sort((a, b) => a.bar!.index - b.bar!.index);
  const center = resActions
    .filter((a) => a.bar!.position === "center")
    .sort((a, b) => a.bar!.index - b.bar!.index);
  const right = resActions
    .filter((a) => a.bar!.position === "right")
    .sort((a, b) => a.bar!.index - b.bar!.index);

  return {
    left,
    center,
    right,
  };
});

export const ListMoreItems = computed(() => {
  const inBar = barItems.value
  const inbarFlat = [...inBar.left, ...inBar.center, ...inBar.right]
  return barActions.filter(a => a.list).filter(item =>  !item.list!.hide?.()).filter(item => {
    return !inbarFlat.find(i => i.name === item.name)
  }).map(item => item.list!).sort((a, b) => a.index - b.index)
})
